// Authentication & User Routes
import {
  ADD_USER_ROUTE,
  AUTH_LINKS,
  PROFILE_ROUTE,
  REPORT_USERS_ROUTE,
  STRIPE_CHECKOUT_ROUTE_WITH_ID,
  STRIPE_PLANS_ROUTE,
  STRIPE_SUBSCRIPTION_EXPIRED_ROUTE,
  USERS_ROUTE,
  VIEW_USER_STAFF_WITH_ID_ROUTE,
  VIEW_USER_WITH_ID_ROUTE,
} from 'constants/index';

// Dashboard & Settings
import { DASHBOARD_ROUTE, SETTINGS_ROUTE } from 'constants/index';

// Staff Management
import { ADD_STAFF_ROUTE, STAFF_ROUTE, STAFF_VIEW_WITH_ID_ROUTE } from 'constants/index';

// Supplier Management
import {
  ADD_SUPPLIER_ROUTE,
  DUPLICATE_SUPPLIER_WITH_ID_ROUTE,
  EDIT_SUPPLIER_WITH_ID_ROUTE,
  SUPPLIER_ROUTE,
} from 'constants/index';

// Ingredient Management
import {
  ADD_INGREDIENT_ROUTE,
  DUPLICATE_INGREDIENT_WITH_ID_ROUTE,
  EDIT_INGREDIENT_WITH_ID_ROUTE,
  INGREDIENTS_ROUTE,
} from 'constants/index';

// Bottle Management
import {
  ADD_BOTTLE_CAPACITY_ROUTE,
  ADD_BOTTLE_PRICE_ROUTE,
  ADD_BOTTLE_SIZE_ROUTE,
  BOTTLE_CAPACITY_ROUTE,
  BOTTLE_PRICE_ROUTE,
  BOTTLE_SIZE_ROUTE,
  EDIT_BOTTLE_CAPACITY_WITH_ID_ROUTE,
  EDIT_BOTTLE_PRICE_WITH_ID_ROUTE,
  EDIT_BOTTLE_SIZE_WITH_ID_ROUTE,
} from 'constants/index';

// Serving Size
import {
  ADD_SERVING_SIZE_ROUTE,
  EDIT_SERVING_SIZE_ROUTE_WITH_ID_ROUTE,
  SERVING_SIZE_ROUTE,
} from 'constants/index';

// Sweeteners
import {
  ADD_SWEETENER_COMPONENT_ROUTE,
  ADD_SWEETENER_ROUTE,
  EDIT_SWEETENER_COMPONENT_WITH_ID_ROUTE,
  EDIT_SWEETENER_WITH_ID_ROUTE,
  SWEETENER_COMPONENT_ROUTE,
  SWEETENER_ELEMENT_WITH_ID_ROUTE,
  SWEETENER_ROUTE,
} from 'constants/index';

// Excipients
import {
  ADD_EXCIPIENT_LABEL_ROUTE,
  ADD_EXCIPIENT_ROUTE,
  ADD_EXCIPIENT_TYPES_ROUTE,
  EDIT_EXCIPIENT_LABEL_WITH_ID_ROUTE,
  EDIT_EXCIPIENT_TYPES_WITH_ID_ROUTE,
  EDIT_EXCIPIENT_WITH_ID_ROUTE,
  EXCIPIENT_LABEL_ROUTE,
  EXCIPIENT_ROUTE,
  EXCIPIENT_TYPES_ROUTE,
} from 'constants/index';

// Syrup Base Ingredients
import {
  ADD_SYRUP_BASE_INGREDIENTS_ROUTE,
  EDIT_SYRUP_BASE_INGREDIENTS_WITH_ID_ROUTE,
  SYRUP_BASE_INGREDIENTS_ROUTE,
} from 'constants/index';

// Product Ingredients
import {
  ADD_PRODUCT_INGREDIENT_ROUTE,
  EDIT_PRODUCT_INGREDIENT_WITH_ID_ROUTE,
  PRODUCT_INGREDIENT_ROUTE,
} from 'constants/index';

// Product Sizes
import { ADD_PRODUCT_SIZE_ROUTE, EDIT_PRODUCT_SIZE_WITH_ID_ROUTE, PRODUCT_SIZE_ROUTE } from 'constants/index';

// Product Types & Sub-types
import {
  ADD_SUB_PRODUCT_TYPE_ROUTE,
  EDIT_PRODUCT_TYPE_WITH_ID_ROUTE,
  EDIT_SUB_PRODUCT_TYPE_WITH_ID_ROUTE,
  PRODUCT_TYPE_ROUTE,
  SUB_PRODUCT_TYPE_ROUTE,
} from 'constants/index';

// Product Formulations
import {
  ADD_FORMULA_BY_DOSAGE_ROUTE,
  ADD_FORMULA_BY_FACT_BOX_ROUTE,
  ADD_FORMULA_BY_INGREDIENTS_ROUTE,
  DUPLICATE_FORMULA_WITH_ID_ROUTE,
  EDIT_FORMULA_WITH_ID_ROUTE,
  FORMULA_DETAIL_ROUTE_WITH_ID,
  FORMULA_ROUTE,
  PRODUCT_FORMULATION_ROUTE,
} from 'constants/index';

// Product Formulation - Syrup Types
import {
  ADD_PRODUCT_FORMULATION_SYRUP_TYPE_ROUTE,
  EDIT_PRODUCT_FORMULATION_SYRUP_TYPE_WITH_ID_ROUTE,
  EDIT_PRODUCT_FORMULATION_WITH_ID_ROUTE,
  PRODUCT_FORMULATION_SYRUP_TYPE_ROUTE,
  VIEW_PRODUCT_FORMULATION_SYRUP_TYPE_WITH_ID_ROUTE,
} from 'constants/index';

// Product Excipients
import { PRODUCT_EXCIPIENT_WITH_ID_ROUTE } from 'constants/index';

// Coating & Sand Coating
import {
  ADD_SAND_COATING_FORMULATION_ROUTE,
  ADD_SAND_COATING_ROUTE,
  COATING_FORMULATION_COMPONENT_WITH_ID_ROUTE,
  EDIT_SAND_COATING_FORMULATION_WITH_ID_ROUTE,
  EDIT_SAND_COATING_WITH_ID_ROUTE,
  SAND_COATING_FORMULATION_ROUTE,
  SAND_COATING_ROUTE,
} from 'constants/index';

// Sand Components
import {
  ADD_SAND_COMPONENT_ROUTE,
  EDIT_SAND_COMPONENT_WITH_ID_ROUTE,
  SAND_COMPONENT_ROUTE,
} from 'constants/index';

// Reporting Routes
import { REPORT_DOSAGE_FORM_ROUTE, REPORT_INGREDIENTS_ROUTE, REPORT_PLATFORM_ROUTE } from 'constants/index';

// Base Coating
import { ADD_BASE_COATING_ROUTE, EDIT_BASE_COATING_WITH_ID_ROUTE, BASE_COATING_ROUTE } from 'constants/index';

// Flavor
import { ADD_FLAVOR_ROUTE, EDIT_FLAVOR_WITH_ID_ROUTE, FLAVOR_ROUTE } from 'constants/index';

// Capsule Type
import { ADD_CAPSULE_TYPE_ROUTE, EDIT_CAPSULE_TYPE_WITH_ID_ROUTE, CAPSULE_TYPE_ROUTE } from 'constants/index';

// Capsule Price
import {
  CAPSULE_PRICE_ROUTE,
  ADD_CAPSULE_PRICE_ROUTE,
  EDIT_CAPSULE_PRICE_WITH_ID_ROUTE,
} from 'constants/index';

// DV Constraints
import { DV_CONSTRAINTS_ROUTE, EDIT_DV_CONSTRAINTS_WITH_ID_ROUTE } from 'constants/index';

// interfaces
import { AppRoutesType } from 'interfaces';

// Auth Pages
import Signup from 'pages/auth/Signup';
import VerifyOTP from 'pages/auth/VerifyOTP';
import RequestSent from 'pages/auth/RequestSent';
import ResetPassword from 'pages/auth/ResetPassword';
import ForgetPassword from 'pages/auth/ForgetPassword';
import EmailSentSuccess from 'pages/auth/EmailSentSuccess';
import SetPasswordSuccess from 'pages/auth/SetPasswordSuccess';

// Dashboard & Settings Pages
import Dashboard from 'pages/Dashboard';
import Settings from 'pages/Settings';
import Profile from 'pages/Profile';

// Formula Pages
import AddFormulaByDosage from 'pages/FormulaByDosage';
import AddFormulaByFactBox from 'pages/FormulaByFactBox';
import AddFormulaByIngredients from 'pages/FormulaByIngredients';
import FormulaDetailPage from 'pages/FormulaDetail';
import Formulas from 'pages/Formulas';
import DuplicateFormula from 'pages/Formulas/Dosage/Duplicate';
import EditFormula from 'pages/Formulas/Dosage/Edit';

// Ingredient Pages
import Ingredients from 'pages/Ingredients';
import AddIngredient from 'pages/Ingredients/Add/index';
import DuplicateIngredient from 'pages/Ingredients/Duplicate';
import EditIngredient from 'pages/Ingredients/Edit';

// Staff Pages
import Staff from 'pages/Staff';
import AddStaff from 'pages/Staff/Add';
import ViewStaff from 'pages/Staff/Edit';

// User Pages
import Users from 'pages/Users';
import AddUser from 'pages/Users/Add';
import EditUser from 'pages/Users/Edit';
import EditOrgStaff from 'pages/Users/Staff';

// Supplier Pages
import Supplier from 'pages/Supplier';
import AddSupplier from 'pages/Supplier/Add';
import DuplicateSupplier from 'pages/Supplier/Duplicate';
import EditSupplier from 'pages/Supplier/Edit';

// Product Type Pages
import ProductType from 'pages/ProductType';
import EditProductType from 'pages/ProductType/Edit';

// Sub Product Type Pages
import SubProductType from 'pages/SubProductType';
import AddSubProductType from 'pages/SubProductType/Add';
import EditSubProductType from 'pages/SubProductType/Edit';

// Product Formulation Type Pages
import ProductFormulationType from 'pages/ProductFormulationType';
import EditProductFormulationType from 'pages/ProductFormulationType/Edit';

// Product Size Pages
import ProductSize from 'pages/ProductSize';
import AddProductSize from 'pages/ProductSize/Add';
import EditProductSize from 'pages/ProductSize/Edit';

// Excipient Pages
import Excipient from 'pages/Excipient';
import AddExcipient from 'pages/Excipient/Add';
import EditExcipient from 'pages/Excipient/Edit';

// Excipient Label Pages
import ExcipientLabel from 'pages/ExcipientLabel';
import AddExcipientLabel from 'pages/ExcipientLabel/Add';
import EditExcipientLabel from 'pages/ExcipientLabel/Edit';

// Excipient Type Pages
import ExcipientType from 'pages/ExcipientType';
import AddExcipientType from 'pages/ExcipientType/Add';
import EditExcipientType from 'pages/ExcipientType/Edit';

// Product Excipient Pages
import ProductExcipient from 'pages/ProductExcipient';

// Bottle Size Pages
import BottleSize from 'pages/BottleSize';
import AddBottleSize from 'pages/BottleSize/Add';
import EditBottleSize from 'pages/BottleSize/Edit';

// Bottle Price Pages
import BottlePrice from 'pages/BottlePrice';
import AddBottlePrice from 'pages/BottlePrice/Add';
import EditBottlePrice from 'pages/BottlePrice/Edit';

// Bottle Capacity Pages
import BottleCapacity from 'pages/BottleCapacity';
import AddBottleCapacity from 'pages/BottleCapacity/Add';
import EditBottleCapacity from 'pages/BottleCapacity/Edit';

// Sweetener System Pages
import SweetenerSystem from 'pages/SweetenerSystem';
import AddSweetenerSystems from 'pages/SweetenerSystem/Add';
import EditSweetenerSystem from 'pages/SweetenerSystem/Edit';

// Sweetener Element Pages
import SweetenerElement from 'pages/SweetenerElements';

// Sweetener Component Pages
import SweetenerComponent from 'pages/SweetenerComponent';
import AddSweetenerComponent from 'pages/SweetenerComponent/Add';
import EditSweetenerComponent from 'pages/SweetenerComponent/Edit';

// Flavor Pages
import Flavor from 'pages/Flavor';
import AddFlavor from 'pages/Flavor/Add';
import EditFlavor from 'pages/Flavor/Edit';

// Product Ingredient Pages
import ProductIngredient from 'pages/ProductIngredient';
import AddProductIngredient from 'pages/ProductIngredient/Add';
import EditProductIngredient from 'pages/ProductIngredient/Edit';

// Product Ingredient Formulation (Syrup Type) Pages
import FormulationSyrupType from 'pages/FormulationSyrupType';
import AddFormulationSyrupType from 'pages/FormulationSyrupType/Add';
import EditFormulationSyrupType from 'pages/FormulationSyrupType/Edit';
import ViewFormulationSyrupType from 'pages/FormulationSyrupType/View';

// Syrup Base Ingredient Pages
import SyrupBaseIngredients from 'pages/SyrupBaseIngredients';
import AddSyrupBaseIngredient from 'components/main/SyrupBaseIngredients/Add';
import EditSyrupBaseIngredient from 'components/main/SyrupBaseIngredients/Edit';

// Serving Size Pages
import ServingSize from 'pages/ServingSize';
import AddServingSize from 'pages/ServingSize/Add';
import EditServingSize from 'pages/ServingSize/Edit';

// Sand Coating Pages
import SandCoating from 'pages/SandCoating';
import AddSandCoating from 'pages/SandCoating/Add';
import EditSandCoating from 'pages/SandCoating/Edit';

// Sand Coating Formulation Pages
import SandCoatingFormulation from 'pages/SandCoatingFormulation';
import AddSandCoatingFormulation from 'pages/SandCoatingFormulation/Add';
import EditSandCoatingFormulation from 'pages/SandCoatingFormulation/Edit';

// Sand Component Pages
import SandComponent from 'pages/SandComponent';
import AddSandComponent from 'pages/SandComponent/Add';
import EditSandComponent from 'pages/SandComponent/Edit';

// Coating Formulation Component Pages
import CoatingFormulationComponent from 'pages/CoatingFormulationComponent';

// Reporting Pages
import DosageFormReports from 'pages/Reports/DosageForm';
import IngredientsReports from 'pages/Reports/Ingredients';
import PlatformReports from 'pages/Reports/Platform';
import UsersReports from 'pages/Reports/Users';

// Route Guards
import { SuperAdminGuard } from 'routes/Guards/SuperAdminGuard';
import { AdminGuard } from './Guards/AdminGuard';
import { AdminOrStaffGuard } from './Guards/AdminOrStaffGuard';
import { SuperOrAdminGuard } from './Guards/SuperOrAdminGuard';
import { SuperOrAdminOrStaffGuard } from './Guards/SuperOrAdminOrStaffGuard';

// Stripe pages
import Plans from 'pages/Plans';
import Checkout from 'pages/Checkout';
import SubscriptionExpired from 'pages/SubscriptionExpired';

// capsule type pages
import CapsuleType from 'pages/CapsuleType';
import AddCapsuleType from 'pages/CapsuleType/Add';
import EditCapsuleType from 'pages/CapsuleType/Edit';

// capsule price pages
import CapsulePrice from 'pages/CapsulePrices';
import AddCapsulePrice from 'pages/CapsulePrices/Add';
import EditCapsulePrice from 'pages/CapsulePrices/Edit';

// base coating pages
import BaseCoating from 'pages/BaseCoating';
import AddBaseCoating from 'pages/BaseCoating/Add';
import EditBaseCoating from 'pages/BaseCoating/Edit';

// DV Constraints pages
import DvConstraints from 'pages/DvConstraints';
import EditDvConstraints from 'pages/DvConstraints/Edit';

export const appRoutes: AppRoutesType[] = [
  // Super Admin Private Routes

  // Product Ingredient formulation syrup type Routes Start
  {
    id: 'product-ingredient-listing-formulation-syrup-type',
    url: PRODUCT_FORMULATION_SYRUP_TYPE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <FormulationSyrupType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-product-ingredient-formulation-syrup-type',
    url: ADD_PRODUCT_FORMULATION_SYRUP_TYPE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddFormulationSyrupType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-product-ingredient-formulation-syrup-type',
    url: EDIT_PRODUCT_FORMULATION_SYRUP_TYPE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditFormulationSyrupType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'view-product-ingredient-formulation-syrup-type',
    url: VIEW_PRODUCT_FORMULATION_SYRUP_TYPE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <ViewFormulationSyrupType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Sand Coating Routes Start
  {
    id: 'sand-coating-listing',
    url: SAND_COATING_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <SandCoating />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-sand-coating',
    url: ADD_SAND_COATING_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddSandCoating />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'edit-sand-coating',
    url: EDIT_SAND_COATING_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditSandCoating />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Sand Coating components Routes Start
  {
    id: 'sand-coating-component-listing',
    url: SAND_COMPONENT_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <SandComponent />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-sand-coating-component',
    url: ADD_SAND_COMPONENT_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddSandComponent />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-sand-coating-component',
    url: EDIT_SAND_COMPONENT_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditSandComponent />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Sand Coating Formulation Routes Start
  {
    id: 'sand-coating-formulation-listing',
    url: SAND_COATING_FORMULATION_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <SandCoatingFormulation />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-sand-coating-formulation',
    url: ADD_SAND_COATING_FORMULATION_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddSandCoatingFormulation />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'edit-sand-coating-formulation',
    url: EDIT_SAND_COATING_FORMULATION_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditSandCoatingFormulation />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Sand Coating formulation routes end

  // sand Coating formulation Component routes start

  {
    id: 'coating-formulation-component',
    url: COATING_FORMULATION_COMPONENT_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <CoatingFormulationComponent />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // sand Coating formulation Component routes end

  // Product Ingredient Routes Start
  {
    id: 'product-ingredient-listing',
    url: PRODUCT_INGREDIENT_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <ProductIngredient />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-product-ingredient',
    url: ADD_PRODUCT_INGREDIENT_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddProductIngredient />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'edit-product-ingredient',
    url: EDIT_PRODUCT_INGREDIENT_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditProductIngredient />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // User Routes Start
  {
    id: 'user',
    url: USERS_ROUTE,
    element: (
      <SuperAdminGuard>
        <Users />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-user',
    url: ADD_USER_ROUTE,
    element: (
      <SuperAdminGuard>
        <AddUser />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-user',
    url: VIEW_USER_WITH_ID_ROUTE,
    element: (
      <SuperAdminGuard>
        <EditUser />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-user-staff',
    url: VIEW_USER_STAFF_WITH_ID_ROUTE,
    element: (
      <SuperAdminGuard>
        <EditOrgStaff />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },

  // User Routes End

  // Supplier routes start

  {
    id: 'supplier',
    url: SUPPLIER_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <Supplier />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-supplier',
    url: ADD_SUPPLIER_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddSupplier />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-supplier',
    url: EDIT_SUPPLIER_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditSupplier />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'duplicate-supplier',
    url: DUPLICATE_SUPPLIER_WITH_ID_ROUTE,
    element: (
      <AdminGuard>
        <DuplicateSupplier />
      </AdminGuard>
    ),
    isPrivate: true,
  },

  // Supplier routes end

  // Product Type routes start

  {
    id: 'product',
    url: PRODUCT_TYPE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <ProductType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-product',
    url: EDIT_PRODUCT_TYPE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditProductType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Product Type routes end

  // Sub Product Type routes start

  {
    id: 'add-sub-product',
    url: ADD_SUB_PRODUCT_TYPE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddSubProductType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'sub-product',
    url: SUB_PRODUCT_TYPE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <SubProductType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-sub-product',
    url: EDIT_SUB_PRODUCT_TYPE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditSubProductType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Sub Product Type routes end

  // Product Size routes start
  {
    id: 'product-size',
    url: PRODUCT_SIZE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <ProductSize />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-product-size',
    url: ADD_PRODUCT_SIZE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddProductSize />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-product-size',
    url: EDIT_PRODUCT_SIZE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditProductSize />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Product Size routes end

  // Product Formulation routes start
  {
    id: 'product-formulation',
    url: PRODUCT_FORMULATION_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <ProductFormulationType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-product-formulation',
    url: EDIT_PRODUCT_FORMULATION_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditProductFormulationType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Product Formulation routes end

  // Excipient routes start
  {
    id: 'excipient',
    url: EXCIPIENT_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <Excipient />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-excipient',
    url: EDIT_EXCIPIENT_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditExcipient />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-excipient',
    url: ADD_EXCIPIENT_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddExcipient />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Excipient routes end

  // Excipient Label routes start

  {
    id: 'excipient-label',
    url: EXCIPIENT_LABEL_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <ExcipientLabel />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-excipient-label',
    url: EDIT_EXCIPIENT_LABEL_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditExcipientLabel />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-excipient-label',
    url: ADD_EXCIPIENT_LABEL_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddExcipientLabel />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  // Excipient Label routes end

  // Excipient Type routes start

  {
    id: 'excipient-types',
    url: EXCIPIENT_TYPES_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <ExcipientType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-excipient-types',
    url: EDIT_EXCIPIENT_TYPES_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditExcipientType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-excipient-type',
    url: ADD_EXCIPIENT_TYPES_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddExcipientType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Excipient Type routes end

  // Product Excipient  routes start

  {
    id: 'product-excipient',
    url: PRODUCT_EXCIPIENT_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <ProductExcipient />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Product Excipient  routes end

  // Bottle Size routes start
  {
    id: 'bottle-size',
    url: BOTTLE_SIZE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <BottleSize />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-bottle-size',
    url: EDIT_BOTTLE_SIZE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditBottleSize />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-bottle-size',
    url: ADD_BOTTLE_SIZE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddBottleSize />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Serving Size routes start
  {
    id: 'serving-size',
    url: SERVING_SIZE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <ServingSize />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-serving-size',
    url: EDIT_SERVING_SIZE_ROUTE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditServingSize />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-serving-size',
    url: ADD_SERVING_SIZE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddServingSize />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Bottle Size routes end

  // Bottle Price routes start
  {
    id: 'bottle-price',
    url: BOTTLE_PRICE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <BottlePrice />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-bottle-price',
    url: ADD_BOTTLE_PRICE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddBottlePrice />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-bottle-price',
    url: EDIT_BOTTLE_PRICE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditBottlePrice />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Bottle Price routes end

  // Bottle Capacity routes start

  {
    id: 'bottle-capacity',
    url: BOTTLE_CAPACITY_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <BottleCapacity />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-bottle-capacity',
    url: EDIT_BOTTLE_CAPACITY_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditBottleCapacity />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-bottle-capacity',
    url: ADD_BOTTLE_CAPACITY_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddBottleCapacity />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Bottle Capacity routes end

  // Flavor routes start
  {
    id: 'flavor',
    url: FLAVOR_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <Flavor />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-flavor',
    url: ADD_FLAVOR_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddFlavor />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-flavor',
    url: EDIT_FLAVOR_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditFlavor />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Flavor routes end

  // Sweetener routes start
  {
    id: 'sweetener',
    url: SWEETENER_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <SweetenerSystem />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-sweetener',
    url: ADD_SWEETENER_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddSweetenerSystems />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-sweetener',
    url: EDIT_SWEETENER_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditSweetenerSystem />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Sweetener routes end

  //Sweetener Elements routes

  {
    id: 'sweetener-element',
    url: SWEETENER_ELEMENT_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <SweetenerElement />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Sweetener Elements routes end

  // Sweetener Component routes start
  {
    id: 'sweetener-component',
    url: SWEETENER_COMPONENT_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <SweetenerComponent />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-sweetener-component',
    url: ADD_SWEETENER_COMPONENT_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddSweetenerComponent />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-sweetener-component',
    url: EDIT_SWEETENER_COMPONENT_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditSweetenerComponent />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // Reporting routes start
  {
    id: 'reporting-users',
    url: REPORT_USERS_ROUTE,
    element: (
      <SuperAdminGuard>
        <UsersReports />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'reporting-platform',
    url: REPORT_PLATFORM_ROUTE,
    element: (
      <SuperAdminGuard>
        <PlatformReports />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'reporting-dosage-form',
    url: REPORT_DOSAGE_FORM_ROUTE,
    element: (
      <SuperAdminGuard>
        <DosageFormReports />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'reporting-ingredient',
    url: REPORT_INGREDIENTS_ROUTE,
    element: (
      <SuperAdminGuard>
        <IngredientsReports />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },

  // Admin and Staff Private Routes

  // Formula Routes Start
  {
    id: 'formula',
    url: FORMULA_ROUTE,
    element: (
      <AdminOrStaffGuard>
        <Formulas />
      </AdminOrStaffGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-formula-by-dosage',
    url: ADD_FORMULA_BY_DOSAGE_ROUTE,
    element: (
      <AdminOrStaffGuard>
        <AddFormulaByDosage />
      </AdminOrStaffGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-formula-by-ingredients',
    url: ADD_FORMULA_BY_INGREDIENTS_ROUTE,
    element: (
      <AdminOrStaffGuard>
        <AddFormulaByIngredients />
      </AdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-formula-by-fact-box',
    url: ADD_FORMULA_BY_FACT_BOX_ROUTE,
    element: (
      <AdminOrStaffGuard>
        <AddFormulaByFactBox />
      </AdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'edit-formula',
    url: EDIT_FORMULA_WITH_ID_ROUTE,
    element: (
      <AdminOrStaffGuard>
        <EditFormula />
      </AdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'duplicate-formula',
    url: DUPLICATE_FORMULA_WITH_ID_ROUTE,
    element: (
      <AdminOrStaffGuard>
        <DuplicateFormula />
      </AdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'formula-detail',
    url: FORMULA_DETAIL_ROUTE_WITH_ID,
    element: (
      <AdminOrStaffGuard>
        <FormulaDetailPage />
      </AdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  // Formula Routes End

  // Staff Routes Start
  {
    id: 'staff',
    url: STAFF_ROUTE,
    element: (
      <AdminGuard>
        <Staff />
      </AdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-staff',
    url: ADD_STAFF_ROUTE,
    element: (
      <AdminGuard>
        <AddStaff />
      </AdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-staff',
    url: STAFF_VIEW_WITH_ID_ROUTE,
    element: (
      <AdminGuard>
        <ViewStaff />
      </AdminGuard>
    ),
    isPrivate: true,
  },

  // Staff Routes End

  // Common Private Routes

  // Stripe Routes
  {
    id: 'stripe-checkout',
    url: STRIPE_CHECKOUT_ROUTE_WITH_ID,
    element: <Checkout />,
    isPrivate: true,
  },
  {
    id: 'stripe-plans',
    url: STRIPE_PLANS_ROUTE,
    element: <Plans />,
    isPrivate: true,
  },

  {
    id: 'stripe-subscription-expired',
    url: STRIPE_SUBSCRIPTION_EXPIRED_ROUTE,
    element: <SubscriptionExpired />,
    isPrivate: true,
  },

  // Dashboard Route
  {
    id: 'dashboard',
    url: DASHBOARD_ROUTE,
    element: (
      <SuperOrAdminOrStaffGuard>
        <Dashboard />
      </SuperOrAdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  // Profile Route
  {
    id: 'profile',
    url: PROFILE_ROUTE,
    element: (
      <SuperOrAdminOrStaffGuard>
        <Profile />
      </SuperOrAdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  // Setting Route
  {
    id: 'settings',
    url: SETTINGS_ROUTE,
    element: (
      <SuperOrAdminOrStaffGuard>
        <Settings />
      </SuperOrAdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  // Ingredient Routes Start
  {
    id: 'ingredients',
    url: INGREDIENTS_ROUTE,
    element: (
      <SuperOrAdminOrStaffGuard>
        <Ingredients />
      </SuperOrAdminOrStaffGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-ingredients',
    url: ADD_INGREDIENT_ROUTE,
    element: (
      <SuperOrAdminOrStaffGuard>
        <AddIngredient />
      </SuperOrAdminOrStaffGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-ingredients',
    url: EDIT_INGREDIENT_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminOrStaffGuard>
        <EditIngredient />
      </SuperOrAdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'duplicate-ingredients',
    url: DUPLICATE_INGREDIENT_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminOrStaffGuard>
        <DuplicateIngredient />
      </SuperOrAdminOrStaffGuard>
    ),
    isPrivate: true,
  },

  // Ingredient Routes End

  // public routes
  {
    id: 'forgot-password',
    url: AUTH_LINKS.FORGOT_PASSWORD_LINK,
    element: <ForgetPassword />,
    isPrivate: false,
  },
  {
    id: 'signup',
    url: AUTH_LINKS.SIGN_UP_LINK,
    element: <Signup />,
    isPrivate: false,
  },

  {
    id: 'request-sent',
    url: AUTH_LINKS.REQUEST_SENT_SUCCESSFULLY,
    element: <RequestSent />,
    isPrivate: false,
  },
  {
    id: 'set-password',
    url: AUTH_LINKS.SET_PASSWORD_LINK,
    element: <ResetPassword />,
    isPrivate: false,
  },
  {
    id: 'password-success',
    url: AUTH_LINKS.PASSWORD_SUCCESS,
    element: <SetPasswordSuccess />,
    isPrivate: false,
  },
  {
    id: 'email-sent-success',
    url: AUTH_LINKS.EMAIL_SENT_SUCCESS_LINK,
    element: <EmailSentSuccess />,
    isPrivate: false,
  },

  {
    id: 'verify-otp',
    url: AUTH_LINKS.VERIFY_OTP,
    element: <VerifyOTP />,
    isPrivate: false,
  },

  {
    id: 'syrup-base-ingredient',
    url: SYRUP_BASE_INGREDIENTS_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <SyrupBaseIngredients />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-syrup-base-ingredients',
    url: ADD_SYRUP_BASE_INGREDIENTS_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddSyrupBaseIngredient />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-syrup-base-ingredients',
    url: EDIT_SYRUP_BASE_INGREDIENTS_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditSyrupBaseIngredient />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // capsule type routes
  {
    id: 'capsule-type',
    url: CAPSULE_TYPE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <CapsuleType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-capsule-type',
    url: ADD_CAPSULE_TYPE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddCapsuleType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-capsule-type',
    url: EDIT_CAPSULE_TYPE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditCapsuleType />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // capsule price routes
  {
    id: 'capsule-price',
    url: CAPSULE_PRICE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <CapsulePrice />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  {
    id: 'add-capsule-price',
    url: ADD_CAPSULE_PRICE_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddCapsulePrice />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-capsule-price',
    url: EDIT_CAPSULE_PRICE_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditCapsulePrice />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // base coating routes start
  {
    id: 'base-coating',
    url: BASE_COATING_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <BaseCoating />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'add-base-coating',
    url: ADD_BASE_COATING_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <AddBaseCoating />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-base-coating',
    url: EDIT_BASE_COATING_WITH_ID_ROUTE,
    element: (
      <SuperOrAdminGuard>
        <EditBaseCoating />
      </SuperOrAdminGuard>
    ),
    isPrivate: true,
  },

  // base coating routes end

  // dv constraints routes start
  {
    id: 'dv-constraints',
    url: DV_CONSTRAINTS_ROUTE,
    element: (
      <SuperAdminGuard>
        <DvConstraints />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },
  {
    id: 'edit-dv-constraints',
    url: EDIT_DV_CONSTRAINTS_WITH_ID_ROUTE,
    element: (
      <SuperAdminGuard>
        <EditDvConstraints />
      </SuperAdminGuard>
    ),
    isPrivate: true,
  },
];
